import type { FaireProductEntity } from "../../entity_types/product";

export const p_nxve7pnej7: FaireProductEntity = {
  token: "p_nxve7pnej7",
  type: "product",
  name: "Leonardo Oversized Cotton Tea Towels in 3 Neutral Colors",
  brandName: "Foreside Home & Garden",
  imageUrl:
    "https://cdn.faire.com/fastly/17f8b269f0cfdb192c21cac0ca7a36e6c6adeebe1aaf743d8b04167adaa18715.jpeg",
  priceDollars: 15.4,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/ac3c5d2b52fb3c740c3ac6bf9077c6d0d9645200aa18677454d971845f81a599.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
